import { Box, styled } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

export const PeriodCardContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
  textAlign: 'center',
  padding: '22px 18px',
}));

export const Discount = styled(CustomTypography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  color: selected
    ? theme.palette.custom.black[10]
    : theme.palette.custom.black[20],
  fontSize: '16px',
}));
